module.exports = __webpack_public_path__ + "img/DTHU.aead3196.png";